import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';

import { OptionalType } from '../../../../models/types/optional.type';
import { GeneralMeetingsResource } from '../../../../services/resources/general-meetings.resource';

@Component({
    selector: 'sl-presence-edit',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './presence-edit.dialog.html'
})
export class PresenceEditDialog {
    readonly isSaving = signal(false);

    readonly presencePowerPointFileData = signal<OptionalType<string>>(undefined);
    readonly hasUpdatedPowerPoint = signal(false);
    readonly presencePowerPointFileDataHref = computed(
        () => `data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,${this.presencePowerPointFileData()}`
    );

    readonly data: { presencePowerPointFileData?: string } = inject(MAT_DIALOG_DATA);
    readonly matDialogRef = inject(MatDialogRef);
    readonly generalMeetingsResource = inject(GeneralMeetingsResource);

    constructor() {
        this.presencePowerPointFileData.set(this.data.presencePowerPointFileData);
    }

    onFileSelected(event: Event): void {
        const reader = new FileReader();

        const target = event.target as HTMLInputElement;
        if (target?.files && target.files.length > 0) {
            const file = target.files[0];

            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result?.toString()?.split(',')?.at(1);
                this.presencePowerPointFileData.set(base64String);
                this.hasUpdatedPowerPoint.set(true);
            };
        }
    }

    saveSettings(): void {
        if (this.hasUpdatedPowerPoint()) {
            this.isSaving.set(true);
            this.generalMeetingsResource
                .uploadGmPresencePowerPoint(this.presencePowerPointFileData()!)
                .pipe(finalize(() => this.isSaving.set(false)))
                .subscribe(() => {
                    this.matDialogRef.close({ updatedData: this.presencePowerPointFileData() });
                });
        } else {
            this.matDialogRef.close();
        }
    }
}
